import { Outlet } from "react-router-dom";

const ReportsLayout = function () {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default ReportsLayout;
